<mat-select [required]="to.required" [placeholder]="to.placeholder" [multiple]="to.isMultiSelect" [formlyAttributes]="field"
  [disabled]="to.disabled || to.readonly" [(value)]="selectedValue" (selectionChange)="onSelectedChange($event)"
  (opened)="onOpen()"
  (closed)="onClosed()"
  (focus)="onFocusIn()" (blur)="onFocusOut()">
  @if (to.objectChooserOptions?.length) {
    <mat-form-field class="search-full-width">
      <!-- todo: fix float label animation after v21 update EIM-36958
      <mat-label>Search</mat-label> -->
      <input  type="text" matInput placeholder="Type to search" [formControl]="searchBar" (keydown)="$event.stopPropagation()" #fromFieldInput>
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    @for (item of to.objectChooserOptions; track item?.value; let i = $index) {
    <mat-option [value]="item?.value">{{item.label | i18n_label}}
    </mat-option>
    }
    @if (!showMoreHide) {
    <div class="button-style">
      <button mat-raised-button class="btn basic" type="button" (click)="showMoreObjects()">{{ 'Show More' | translate
        }}</button>
    </div>
    }
  } @else {
    <mat-form-field class="search-full-width">
      <!-- todo: fix float label animation after v21 update EIM-36958
      <mat-label>Search</mat-label> -->
      <input type="text" matInput [formControl]="searchBar"
        (keydown)="$event.stopPropagation()" placeholder="Type to search">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <div class="options-style">
      <mat-option disabled>No options to select</mat-option>
    </div>
  }
</mat-select>
